export default "__VITE_ASSET__04f650a3__"